class GalleryThumbs extends HTMLElement {
  constructor() {
    super();
    this.thumbs = this.querySelectorAll('.js-gallery-thumb');
    this.mediaGallery = document.querySelector('media-gallery');

    if(this.getAttribute('data-is-disabled') === 'true') return;

    this.addEventListener('click', e => {
      if(e.target.closest('.js-gallery-thumb')) {
        this.updateGallery(e.target.closest('.js-gallery-thumb'))
      }
    })
  }

  updateThumbs(clickedImageIndex) {
    this.thumbs.forEach(thumb => thumb.classList.remove('is-active'))
    this.thumbs[clickedImageIndex].classList.add('is-active');
  }

  updateGallery(clickedThumb) {
    const thumbIndex = clickedThumb.getAttribute('data-slide-index');
    if(!thumbIndex) return;

    this.thumbs.forEach(thumb => thumb.classList.remove('is-active'))
    clickedThumb.classList.add('is-active');

    this.mediaGallery.thumbClickHandler(thumbIndex);
  }
}

customElements.define('gallery-thumbs', GalleryThumbs);
